import { FaUserCircle } from 'react-icons/fa';

function LoginLink() {
  return (
    <div>
      <FaUserCircle height={1.5} width={1.5} />
      <span className="ml-2">Login ou Cadastre-se</span>
    </div>
  );
}

export default LoginLink;
